import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { QuestionCircle, SmsIcon, StarIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/faq')({
  loader: ({ context }) => {
    context.groupLabel = 'faq.sidebar.title';
    context.childRoutes = [
      {
        id: 'faq.sidebar.menu.reviewRatings',
        label: 'Review & Ratings',
        path: '/faq/review-ratings',
        icon: StarIcon,
      },
      {
        id: 'faq.sidebar.menu.inquiry',
        label: 'Inquiry',
        path: '/faq/inquiry',
        icon: SmsIcon,
      },
      {
        id: 'faq.sidebar.menu.complaints',
        label: 'Complaints',
        path: '/faq/complaints',
        icon: QuestionCircle,
      },
    ];

    return {
      crumb: <CrumbTitle title="FAQs" id="faq.crumb.faqs" icon={QuestionCircle} />,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
